import React from 'react';

import {LocalFullDate} from 'modules/Common/components/LocalDateTime';

export default function FootballLiveHomeHeader() {
  return (
    <div className="footballLiveHomeHeader">
      <h1>Live Scores</h1>
      <h2><LocalFullDate iso={new Date()}/></h2>
    </div>
  );
}



// WEBPACK FOOTER //
// ./modules/Football/components/FootballLiveHomeHeader.js